<template>
<div class="page">
  <div>
    <v-dialog :value="exporting" persistent width="500">
      <v-card color="primary" dark class="pa-4">
        <v-card-text style="color:#fff">
          Пожалуйста подождите, идет экспорт...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="d-flex flex-nowrap align-center py-1 mb-3" :style="'gap:60px'">
      <div class="d-flex flex-nowrap" :style="'gap:4px'">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" class="d-inline-block">
              <v-btn
                color="primary"
                class=" icon px-0"
                outlined
                v-bind="attrs"
                :disabled="!active"
                :loading="exporting"
              >
                <v-icon :color="active ? 'primary' : '#9BA1B5'">mdi-upload</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Выгрузить в Excel</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" class="d-inline-block">
              <v-btn v-if="$store.getters['auth/isAllowed']('view_testresultscompliencereport')"
                     color="primary" class="px-0 icon" outlined v-bind="attrs" :disabled="isFilterEmpty" @click="clearFilterAll()">
                <v-icon :color="isFilterEmpty ? '#9BA1B5' : 'primary'">mdi-filter-remove-outline</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Сбросить все фильтры</span>
        </v-tooltip>
      </div>
      <div>
        <div class="d-inline-block">
          <v-menu
            v-model="datePickerShow"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="dateJoinedFilter || null"
                label="Выбрать дату"
                append-icon="mdi-calendar"
                :prepend-inner-icon="dateJoinedFilter.length ? 'mdi-close' : null"
                @click:prepend-inner="clearJoinedDateFilter"
                class="font-sm"
                dense readonly outlined hide-details
                v-bind="attrs"
                v-on="on"
              />
            </template>

            <v-date-picker
              v-model="selectedDate"
              no-title
              locale="ru-RU"
              range
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="cancelJoinedDateFilter"> Отменить</v-btn>
              <v-btn text color="primary" @click="applyJoinedDateFilter" :disabled="!!dateJoinedFilter.length > 1"> OK</v-btn>
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <combo-box
        :dense="true"
        :label="'ФИО менеджера'"
        :outline="true"
        :items="managers"
        :offset-y="true"
        :fieldsForSearch="['first_name','last_name']"
        :model-value="currentManager"
        @update:modelValue="setManager"
        @search="debouncedSetFilterName"
      />
<!--      <custom-select-->
<!--        :dense="true"-->
<!--        :label="'Статус тестирования'"-->
<!--        :outline="true"-->
<!--        :items="statuses"-->
<!--        :offset-y="true"-->
<!--        :model-value="currentStatus"-->
<!--        @update:model="setStatusTesting"-->
<!--      />-->
      <v-btn  @click="createGraph">
        Построить
      </v-btn>
    </div>

  </div>
  <div class="col-12 d-flex align-center pt-6 pb-3">
    <h1 class="font-lg">История расходов тестов</h1>
  </div>
  <BarChart :data="chartData" v-show="chartData.datasets.length"/>
  <div v-show="!chartData.datasets.length">
    <div
      :class="' d-flex align-center bg-whiter  justify-space-between '"
    >
      <div>
        <v-img
          src="@/assets/images/adminPanel/empty_star.webp"
          max-width="136px"
          :class="'BannerPreview__img'"

        />
      </div>
      <div :class="'BannerPreview__title'">Данные по расходам теста остутствуют</div>
      <div>
        <v-img
          src="@/assets/images/adminPanel/empty_star.webp"
          max-width="136px"
          :class="'BannerPreview__img'"
        />
      </div>
    </div>
  </div>

</div>
</template>

<script>
import { TESTING_STATUSES_TITLES } from '@/common/constants/testingStatuses';
import { mapActions, mapGetters } from 'vuex';
import ComboBox from '@/components/ui/ComboBox.vue';
import { debounce } from 'lodash';
import BarChart from '@/components/ui/BarChart.vue';

export default {
  name: 'ManagersGraph',
  components: {
    ComboBox,
    // CustomSelect,
    BarChart,
  },
  props: {
    chartData: {
      type: Object,
      default: () => {
      },
    },
    active: Boolean,
  },
  computed: {
    ...mapGetters({
      isFilterEmpty: 'users/managers/isFilterEmpty',
      stdTests: 'tests/allowedTests',
      managers: 'users/managers/managers',
      manager: 'users/managers/manager',
    }),
    dateJoinedFilter: {
      get() {
        const start = this.$route.query.dateStart || '';
        const end = this.$route.query.dateEnd || '';
        if (start && end) {
          const startFormatted = this.formatToDDMMYYYY(start);
          const endFormatted = this.formatToDDMMYYYY(end);
          return `${startFormatted} - ${endFormatted}`;
        }
        return '';
      },
      set(newDate) {
        if (typeof newDate === 'string') {
          // Очистка фильтра
          this.$router.push({
            query: {
              ...this.$route.query,
              dateStart: undefined,
              dateEnd: undefined,
            },
          });
        } else if (newDate && (newDate.start || newDate.end)) {
          // Обновление дат (может быть start, end или оба)
          const currentDateStart = this.$route.query.dateStart;
          const currentDateEnd = this.$route.query.dateEnd;
          if ((currentDateStart !== newDate.start) || (currentDateEnd !== newDate.end)) {
            this.$router.push({
              query: {
                ...this.$route.query,
                dateStart: newDate.start !== undefined ? newDate.start : this.$route.query.dateStart,
                dateEnd: newDate.end !== undefined ? newDate.end : this.$route.query.dateEnd,
              },
            });
          }
        }
      },
    },
    selectedDate: {
      get() {
        const start = this.$route.query.dateStart || null;
        const end = this.$route.query.dateEnd || null;

        if (start && end) {
          return [start, end];
        }
        if (start) {
          return [start];
        }
        if (end) {
          return [end];
        }
        return [];
      },
      set(newDateArray) {
        if (!newDateArray || newDateArray.length === 0) {
          // Очистка
          this.dateJoinedFilter = '';
        } else if (newDateArray.length === 1) {
          // Выбрана одна дата - ждем вторую для диапазона
          const currentStart = this.$route.query.dateStart;
          const currentEnd = this.$route.query.dateEnd;

          if (!currentStart && !currentEnd) {
            // Первая дата диапазона
            this.dateJoinedFilter = { start: newDateArray[0] };
          } else if (currentStart && !currentEnd) {
            // Вторая дата диапазона
            this.dateJoinedFilter = { end: newDateArray[0] };
          } else {
            // Сброс и установка новой первой даты
            this.dateJoinedFilter = { start: newDateArray[0] };
          }
        } else if (newDateArray.length === 2) {
          // Выбран полный диапазон
          this.dateJoinedFilter = {
            start: newDateArray[0],
            end: newDateArray[1],
          };
        }
      },
    },
    fieldValidate() {
      return true;
      // const managersValidate = this.currentManager;
      // if (managersValidate) {
      //   return true;
      // }
      // return false;
    }
  },
  data: () => ({
    exporting: false,
    datePickerShow: null,
    statuses: Object.entries(TESTING_STATUSES_TITLES)
      .map(s => ({
        text: s[1],
        value: s[0],
      })),
    currentDate: null,
    currentManager: null,
    currentStatus: null,

  }),
  methods: {
    ...mapActions({
      setFilterName: 'users/managers/setFilterNameWithData',
      loadManager: 'users/managers/loadManager',
      setStatsManger: 'users/managers/setStatsManger'
    }),
    clearJoinedDateFilter() {
      this.$router.push({
        query: {
          ...this.$route.query,
          dateStart: undefined,
          dateEnd: undefined,
        },
      });
    },
    cancelJoinedDateFilter() {
      this.datePickerShow = false;
    },
    applyJoinedDateFilter() {
      this.datePickerShow = false;
    },
    formatToDDMMYYYY(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = String(date.getDate())
        .padStart(2, '0');
      const month = String(date.getMonth() + 1)
        .padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    async setManager(val) {
      if (!val) {
       await this.$router.push({
          query: {
            ...this.$route.query,
            managerId: undefined,
            name: undefined,
          },
        });
        return;
      }
      await this.loadManager(val.id);
      const currentManagerId = this.$route.query.managerId;
      const newManagerId = this.manager?.id?.toString();
      if (currentManagerId !== newManagerId) {
        this.currentManager = this.manager;
        await this.$router.push({
          query: {
            ...this.$route.query,
            managerId: newManagerId,
            name: undefined,
          },
        });
      }
      return this.manager;
    },
    // eslint-disable-next-line func-names
    debouncedSetFilterName: debounce(function (val) {
      this.setFilterName({
        name: val,
        tab: 'graph',
        dateStart: this.selectedDate[0] || undefined,
        dateEnd: this.selectedDate[1] || undefined,
        currentStatus: this.currentStatus?.value || undefined,
      });
    }, 500),
    setStatusTesting(status) {
      const idxStatus = this.statuses.findIndex((t) => t.value === status);
      if (idxStatus !== -1) {
        this.currentStatus = this.statuses[idxStatus];
      }
      this.$router.push({
        query: {
          ...this.$route.query,
          currentStatus: status,
        },
      });
    },
    parseCustomDateToISO(dateStr) {
      const [year, month, day] = dateStr.split('-').map(Number);
      const date = new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
      return date.toISOString();
    },
    async createGraph() {
      const data = {};
      if (this.manager && this.$route.query.managerId) {
        data.manager_id = this.manager.id;
      }
      if (this.dateJoinedFilter.length > 1) {
        data.start_date = this.parseCustomDateToISO(this.selectedDate[0]);
        data.end_date = this.parseCustomDateToISO(this.selectedDate[1]);
      }
       await this.setStatsManger(data);
    },
    getLastMonthPeriod() {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setMonth(endDate.getMonth() - 1);

      return {
        startDate,
        endDate,
        startDateString: startDate.toLocaleDateString('ru-RU'),
        endDateString: endDate.toLocaleDateString('ru-RU'),
        startDateISO: startDate.toISOString().split('T')[0],
        endDateISO: endDate.toISOString().split('T')[0]
      };
    },
  },

  mounted() {
    const {
     currentStatus, managerId
    } = this.$route.query;

    if (currentStatus) {
      const idxStatus = this.statuses.findIndex((t) => t.value === currentStatus);
      if (idxStatus !== -1) {
        this.currentStatus = this.statuses[idxStatus];
      } else {
        this.$router.push({
          query: {
            ...this.$route.query,
            currentStatus: undefined,
          },
        });
      }
    }

    if (managerId) {
      this.setManager({ id: managerId })
        .then((result) => {
          this.currentManager = result;
        })
        .catch((error) => {
          throw error;
        });
    }
    const currentMonthPeriod = this.getLastMonthPeriod();
    if (currentMonthPeriod && currentMonthPeriod.startDateISO) {
      this.selectedDate = [
        currentMonthPeriod.startDateISO,
        currentMonthPeriod.endDateISO
      ];
    }
  },
};
</script>

<style>

</style>
